function RecurringTaskForm(props) {
  const {
    editingRecurringId,
    newRecurringTask,
    setNewRecurringTask,
    recurringTaskTime,
    setRecurringTaskTime,
    recurringStatusId,
    setRecurringStatusId,
    recurrenceAnchorType,
    setRecurrenceAnchorType,
    persistenceType,
    setPersistenceType,
    recurrenceType,
    setRecurrenceType,
    recurrenceTypes,
    recurringIntervalValue,
    setRecurringIntervalValue,
    recurringIntervalUnit,
    setRecurringIntervalUnit,
    recurringDaysOfWeek,
    setRecurringDaysOfWeek,
    recurringDayOfMonth,
    setRecurringDayOfMonth,

    recurringMonthlyRuleType,
    setRecurringMonthlyRuleType,

    recurringMonthlyWeekday,
    setRecurringMonthlyWeekday,

    recurringMonthlyWeekNumbers,
    setRecurringMonthlyWeekNumbers,

    recurringMonthOfYear,
    setRecurringMonthOfYear,

    recurringSeasonId,
    setRecurringSeasonId,
    seasons,
    seasonalFrequency,
    setSeasonalFrequency,
    recurrenceStartDate,
    setRecurrenceStartDate,
    recurrenceEndDate,
    setRecurrenceEndDate,
    lastReviewedAt,
    setLastReviewedAt,
    recurringProjectId,
    setRecurringProjectId,
    recurringPriorityId,
    setRecurringPriorityId,
    recurringContextId,
    setRecurringContextId,
    recurringFocusAreaId,
    setRecurringFocusAreaId,
    recurringLocationId,
    setRecurringLocationId,
    recurringTimeOfDayId,
    setRecurringTimeOfDayId,
    recurringImpactId,
    setRecurringImpactId,
    recurringCapacityId,
    setRecurringCapacityId,
    recurringDayTypeId,
    setRecurringDayTypeId,
    recurringIsActive,
    setRecurringIsActive,
    recurringIsPausable,
    setRecurringIsPausable,
    recurringNotes,
    setRecurringNotes,
    taskTimes,
    statusLevels,
    projects,
    priorityLevels,
    contexts,
    focusAreas,
    locations,
    timeOfDayLevels,
    impactLevels,
    capacityLevels,
    dayTypeLevels,
    addRecurringTask,
    updateRecurringTask,
    resetRecurringForm
  } = props

  console.log('RECURRING LOOKUPS:', {
  projects,
  priorityLevels,
  contexts,
  focusAreas,
  locations
})

  return (
    <>
        <div style={{
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    marginBottom: '12px'
  }}>

{/* Task Name */}
    <input
      type="text"
      placeholder="Recurring task..."
      value={newRecurringTask}
      onChange={(e) => setNewRecurringTask(e.target.value)}
    />

      {/*Task Time*/}

      <select
        value={recurringTaskTime}
        onChange={(e) => setRecurringTaskTime(e.target.value)}
      >
        <option value="">Task Time</option>
        {taskTimes.map(t => (
          <option key={t.id} value={t.id}>{t.name}</option>
        ))}
      </select>

      <select
        value={recurringStatusId}
        onChange={(e) => setRecurringStatusId(e.target.value)}
      >
        <option value="">Status</option>
        {statusLevels.map(status => (
          <option key={status.id} value={status.id}>
            {status.name}
          </option>
        ))}
      </select>

      {/* Schedule Based On */}
      <select
        value={recurrenceAnchorType}
        onChange={(e) => setRecurrenceAnchorType(e.target.value)}
      >
        <option value="calendar">Calendar Dates</option>
        <option value="completion">Previous Completion</option>
      </select>

      {/* Persistence */}
      <select
        value={persistenceType}
        onChange={(e) => setPersistenceType(e.target.value)}
      >
        <option value="keep_until_done">Keep Until Done</option>
        <option value="skip_if_missed">Skip If Missed</option>
      </select>

  </div>

<div style={{
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    marginBottom: '12px'
  }}>

    {/* Recurrence Start Date */}
<div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
}}>
    <label style={{
        fontSize: '14px',
        fontWeight: '500'
    }}>
        Starts:
    </label>

    <input
        type="date"
        value={recurrenceStartDate || ''}
        onChange={(e) => setRecurrenceStartDate(e.target.value)}
    />
</div>

   {/* RECURRENCE TYPE */}
<select
  value={recurrenceType}
  onChange={(e) => setRecurrenceType(Number(e.target.value))}
>

  {recurrenceTypes.map(r => (
    <option key={r.id} value={r.id}>
      {r.name}
    </option>
  ))}
</select>

{/* INTERVAL */}
{[1, 2, 3, 4, 5].includes(Number(recurrenceType)) && (
  <>
    <input
      type="number"
      min="1"
      placeholder="Every..."
      value={recurringIntervalValue}
      onChange={(e) => {
        const value = e.target.value
        setRecurringIntervalValue(value)

        if (value) {
          setSeasonalFrequency('')
        }
      }}
      style={{ width: '70px' }}
    />

    <select
      value={recurringIntervalUnit}
      onChange={(e) => setRecurringIntervalUnit(e.target.value)}
    >
      {Number(recurrenceType) === 1 && (
        <option value="days">Days</option>
      )}

      {Number(recurrenceType) === 2 && (
        <option value="weeks">Weeks</option>
      )}

      {Number(recurrenceType) === 3 && (
        <option value="months">Months</option>
      )}

      {Number(recurrenceType) === 4 && (
        <option value="years">Years</option>
      )}

      {Number(recurrenceType) === 5 && (
        <>
          <option value="days">Days</option>
          <option value="weeks">Weeks</option>
          <option value="months">Months</option>
        </>
      )}
    </select>
  </>
)}

{/* WEEKLY DAY SELECTOR */}
{Number(recurrenceType) === 2 && (
  <>
    {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map((label, index) => (
      <label key={index}>
        <input
          type="checkbox"
          checked={recurringDaysOfWeek.includes(index)}
          onChange={(e) => {
            if (e.target.checked) {
              setRecurringDaysOfWeek([...recurringDaysOfWeek, index])
            } else {
              setRecurringDaysOfWeek(
                recurringDaysOfWeek.filter(d => d !== index)
              )
            }
          }}
        />
        {label}
      </label>
    ))}
  </>
)}

{/* ============================================================
    MONTHLY RECURRENCE OPTIONS
    ============================================================ */}

{Number(recurrenceType) === 3 && (
  <div
    style={{
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
      alignItems: 'center',
      width: '100%'
    }}
  >

    {/* Monthly Rule Type */}
    <select
      value={recurringMonthlyRuleType}
      onChange={(e) => {
        const value = e.target.value

        setRecurringMonthlyRuleType(value)

        // Clear the other rule's values when switching.
        if (value === 'day_of_month') {
          setRecurringMonthlyWeekday('')
          setRecurringMonthlyWeekNumbers([])
        } else {
          setRecurringDayOfMonth('')
        }
      }}
    >
      <option value="day_of_month">
        Day of Month
      </option>

      <option value="nth_weekday">
        Weekday of Month
      </option>
    </select>

    {/* ========================================================
        SPECIFIC DAY OF MONTH
        ======================================================== */}

    {recurringMonthlyRuleType === 'day_of_month' && (
      <input
        type="number"
        min="1"
        max="31"
        placeholder="Day (1–31)"
        value={recurringDayOfMonth}
        onChange={(e) =>
          setRecurringDayOfMonth(e.target.value)
        }
      />
    )}

    {/* ========================================================
        NTH WEEKDAY
        ======================================================== */}

    {recurringMonthlyRuleType === 'nth_weekday' && (
      <>

        {/* Weekday */}
        <select
          value={recurringMonthlyWeekday}
          onChange={(e) =>
            setRecurringMonthlyWeekday(e.target.value)
          }
        >
          <option value="">
            Weekday
          </option>

          <option value="0">Sunday</option>
          <option value="1">Monday</option>
          <option value="2">Tuesday</option>
          <option value="3">Wednesday</option>
          <option value="4">Thursday</option>
          <option value="5">Friday</option>
          <option value="6">Saturday</option>
        </select>

        {/* Week Numbers */}
        <div
          style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            flexWrap: 'wrap'
          }}
        >
          {[1, 2, 3, 4, 5].map((weekNumber) => (
            <label
              key={weekNumber}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '3px'
              }}
            >
              <input
                type="checkbox"
                checked={recurringMonthlyWeekNumbers.includes(
                  weekNumber
                )}
                onChange={(e) => {
                  if (e.target.checked) {
                    setRecurringMonthlyWeekNumbers(
                      [...recurringMonthlyWeekNumbers, weekNumber]
                    )
                  } else {
                    setRecurringMonthlyWeekNumbers(
                      recurringMonthlyWeekNumbers.filter(
                        n => n !== weekNumber
                      )
                    )
                  }
                }}
              />

              {weekNumber}
            </label>
          ))}

          {/* Last */}
          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '3px'
            }}
          >
            <input
              type="checkbox"
              checked={recurringMonthlyWeekNumbers.includes(-1)}
              onChange={(e) => {
                if (e.target.checked) {
                  setRecurringMonthlyWeekNumbers(
                    [...recurringMonthlyWeekNumbers, -1]
                  )
                } else {
                  setRecurringMonthlyWeekNumbers(
                    recurringMonthlyWeekNumbers.filter(
                      n => n !== -1
                    )
                  )
                }
              }}
            />

            Last
          </label>
        </div>

      </>
    )}

  </div>
)}

{/* YEARLY MONTH/DAY SELECTORS */}

{Number(recurrenceType) === 4 && (
  <>
    <select
      value={recurringMonthOfYear || ''}
      onChange={(e) =>
        setRecurringMonthOfYear(
          e.target.value ? Number(e.target.value) : ''
        )
      }
    >
      <option value="">Month</option>

      {[
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ].map((month, index) => (
        <option
          key={index + 1}
          value={index + 1}
        >
          {month}
        </option>
      ))}
    </select>

    <select
      value={recurringDayOfMonth || ''}
      onChange={(e) =>
        setRecurringDayOfMonth(
          e.target.value ? Number(e.target.value) : ''
        )
      }
    >
      <option value="">Day</option>

      {Array.from(
        { length: 31 },
        (_, index) => index + 1
      ).map(day => (
        <option
          key={day}
          value={day}
        >
          {day}
        </option>
      ))}
    </select>
  </>
)}

{/* SEASONAL OPTIONS */}
{Number(recurrenceType) === 5 && (
  <>
  
    {/* Season selector */}
    <select
      value={recurringSeasonId}
      onChange={(e) => setRecurringSeasonId(Number(e.target.value))}
    >
      <option value="">Choose Season</option>
      {seasons.map(season => (
        <option key={season.id} value={season.id}>
          {season.name}
        </option>
      ))}
    </select>

{/* Frequency inside season */}
{!Number(recurringIntervalValue) && (
  <select
    value={seasonalFrequency || ''}
    onChange={(e) => {
      const value = e.target.value
      setSeasonalFrequency(value)

      if (value) {
        setRecurringIntervalValue('')
      }
    }}
  >
    <option value="">Repeats During Season</option>
    <option value="once">Once per season</option>
    <option value="daily">Daily</option>
    <option value="weekly">Weekly</option>
    <option value="monthly">Monthly</option>
  </select>
)}
  
    
      {/* Begin Recurrence On */}
      <input
        type="date"
        value={recurrenceStartDate}
        onChange={(e) => setRecurrenceStartDate(e.target.value)}
        title="Begin Recurrence On"
      />

      {/* End Recurrence On */}
      <input
        type="date"
        value={recurrenceEndDate}
        onChange={(e) => setRecurrenceEndDate(e.target.value)}
        title="End Recurrence On"
      />

      {/* Last Reviewed */}
      <input
        type="date"
        value={lastReviewedAt}
        onChange={(e) => setLastReviewedAt(e.target.value)}
        title="Last Reviewed"
      />
    </>
)}
</div>

        <div style={{
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginTop: '10px'
    }}>


{/*Project*/}

    <select
      value={recurringProjectId}
      onChange={(e) => setRecurringProjectId(e.target.value)}
    >
      <option value="">Project</option>
      {projects
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(project => (
        <option key={project.id} value={project.id}>
          {project.name}
        </option>
      ))}
    </select>


{/*Importance - Priority*/}

    <select
      value={recurringPriorityId}
      onChange={(e) => setRecurringPriorityId(e.target.value)}
    >
      <option value="">Importance</option>
      {priorityLevels.map(p => (
        <option key={p.id} value={p.id}>{p.name}</option>
      ))}
    </select>


{/*Context*/}

    <select
      value={recurringContextId}
      onChange={(e) => setRecurringContextId(e.target.value)}
    >
      <option value="">Context</option>
      {contexts
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(context => (
        <option key={context.id} value={context.id}>{context.name}</option>
      ))}
    </select>


{/*Focus Area*/}

    <select
  value={String(recurringFocusAreaId || '')}
  onChange={(e) => setRecurringFocusAreaId(e.target.value)}
>
  <option value="">Focus Area</option>

  {focusAreas.map((area) => (
    <option
      key={area.id}
      value={String(area.id)}
    >
      {area.name}
    </option>
  ))}
</select>

{/*Location*/}

    <select
      value={recurringLocationId}
      onChange={(e) => setRecurringLocationId(e.target.value)}
    >
      <option value="">Location</option>
      {locations
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(location => (
        <option key={location.id} value={location.id}>{location.name}</option>
      ))}
    </select>

      </div>

 {/* META ROW */}
<div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '10px', alignItems: 'center' }}>

  {/* Daily Flow */}
  <select
    value={String(recurringTimeOfDayId || '')}
    onChange={(e) => setRecurringTimeOfDayId(e.target.value)}
  >
    <option value="">Daily Flow</option>
    {timeOfDayLevels.map((flow) => (
      <option key={flow.id} value={String(flow.id)}>
        {flow.name}
      </option>
    ))}
  </select>

  {/* Impact */}
  <select
    value={recurringImpactId}
    onChange={(e) => setRecurringImpactId(e.target.value)}
  >
    <option value="">Impact</option>
    {impactLevels.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))}
  </select>

  {/* Capacity */}
  <select
    value={recurringCapacityId}
    onChange={(e) => setRecurringCapacityId(e.target.value)}
  >
    <option value="">Capacity</option>
    {capacityLevels.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))}
  </select>

  {/* Day Type */}
  <select
    value={String(recurringDayTypeId || '')}
    onChange={(e) => setRecurringDayTypeId(e.target.value)}
  >
    <option value="">Day Type</option>
    {dayTypeLevels.map((dayType) => (
      <option key={dayType.id} value={String(dayType.id)}>
        {dayType.name}
      </option>
    ))}
  </select>

  {/* Active */}
  <label style={{ display:'flex', alignItems:'center', gap:'6px' }}>
    <input
      type="checkbox"
      checked={recurringIsActive}
      onChange={(e) => setRecurringIsActive(e.target.checked)}
    />
    Active
  </label>

  {/* Pausable */}
  <label style={{ display:'flex', alignItems:'center', gap:'6px' }}>
    <input
      type="checkbox"
      checked={recurringIsPausable}
      onChange={(e) => setRecurringIsPausable(e.target.checked)}
    />
    Pausable
  </label>

</div>

{/* NOTES ROW */}
<div style={{ marginTop: '10px' }}>
  <input
    value={recurringNotes}
    onChange={(e) => setRecurringNotes(e.target.value)}
    placeholder="Recurring notes..."
    style={{ width: '100%' }}
  />
</div>

{/* BUTTON ROW */}
<div style={{ marginTop: '10px' }}>
  <button onClick={addRecurringTask}>
    {editingRecurringId ? 'Save Changes' : 'Add Recurring'}
  </button>

  {editingRecurringId && (
    <button
      onClick={resetRecurringForm}
      style={{
        background: '#777',
        color: 'white',
        marginLeft: '10px'
      }}
    >
      Cancel Edit
    </button>
  )}
</div>

</> 
) 
} 

export default RecurringTaskForm